import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import Input from '../shared/Input';
import Drawer from '../shared/Drawer';
import Autocomplete from '../shared/Autocomplete';

import allCountries from '../../constants/countries';

const countriesList = allCountries.map((c) => c.name);

const ProductModal = (props) => {
  const {
    mode = 'create',
    open,
    onClose,
    onSubmit,
    loading,
    productTags = [],
    initialValues,
  } = props;

  const [description, setDescription] = useState('');
  const [sku, setSku] = useState('');
  const [country, setCountry] = useState('');
  const [tags, setTags] = useState([]);

  useEffect(() => {
    if (open && mode === 'update') {
      setDescription(initialValues?.description || '');
      setSku(initialValues?.sku || '');
      setCountry(initialValues?.country || '');
      setTags(initialValues?.tags?.map((tag) => productTags?.find((t) => t.id === tag.id)) || '');
    }
  }, [open, mode, initialValues, productTags]);

  const resetValues = () => {
    setDescription('');
    setSku('');
    setCountry('');
    setTags([]);
  };

  const handleSubmit = async () => {
    const formObj = {
      description: description || '',
      sku: sku || '',
      country: country || '',
      tags: tags || [],
    };
    await onSubmit(formObj);
    resetValues();
  };

  const isDisabled = () => {
    return !sku || !description;
  };

  return (
    <Drawer
      open={open}
      onClose={() => {
        resetValues();
        onClose();
      }}
      title={mode === 'update' ? 'Edit Product' : 'Create Product'}
      subtitle="Enter product details"
      submitText={mode === 'update' ? 'Save Changes' : 'Create'}
      disabled={isDisabled()}
      loading={loading}
      onSubmit={handleSubmit}
    >
      <Box sx={{ minWidth: { xs: 'auto', md: '560px' }, maxWidth:  { xs: 'auto', md: '560px' } }}>
        <Grid container spacing={0}>
          <Grid size={{ xs: 12 }}>
            <Input
              id="sku"
              type="text"
              placeholder=""
              value={sku}
              onChange={(e) => setSku(e.target.value)}
              fullWidth
              label="SKU"
              required
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <div className="p-t-md">
              <Input
                id="description"
                type="text"
                placeholder=""
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                fullWidth
                label="Description"
                required
              />
            </div>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <div className="p-t-md">
              <Autocomplete
                label="Tags"
                value={tags}
                onChange={setTags}
                multiple
                allowCreate
                options={productTags}
                getOptionLabel={(tag) => tag.label}
                placeholder="Add tag"
              />
            </div>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <div className="p-t-md">
              <Autocomplete
                value={country}
                onChange={setCountry}
                options={countriesList}
                label="Country"
              />
            </div>
          </Grid>
        </Grid>
      </Box>
    </Drawer>
  );
};

ProductModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ProductModal;
